import React, { useContext, useEffect, useState } from "react";

import config from "../../app/config";
import { useOktaAuth } from "@okta/okta-react";
import { RCLContext } from "../../components/RCL/RCLProvider";
import { RCL } from "../../components/RCL";
import moment from "moment";
import styles from "./LandingPageVwq.module.scss";
import { PARAGRAPH_FRAGMENT } from "../../fragments/Paragraph.fragment";
import PromptCardGrid from './PromptCardGrid';
import { VWQIcon } from "@sunwing/icons";
import { ParagraphConnector } from "../../components/Paragraph";

const LandingPage = () => {

    const { locale } = useContext(RCLContext);
    const { oktaAuth } = useOktaAuth();
    const [landingPage, setLandingPage] = useState();

    const params = new URL(window.location.href).searchParams;
    let contentfulId = params.get('contentfulId');
    let slug = params.get('slug');
    let query = '';

    if(slug && slug.length > 0){
        query =`  
            ${PARAGRAPH_FRAGMENT}  
                query landingPagesData($slug: String!, $locale: String!, $brandCode:String!) {
                    landingPageCollection(locale: $locale, limit:2, where:{slug: $slug, brand: {brandCode:$brandCode} }) {
                        items {
                            sys {
                                id
                            }
                            displayTitle
                            flyerFileCollection {
                                items {
                                url
                                size
                                description
                                }
                            }
                            flyerImageAsset
                            contentParagraph  { 
                                ...ParagraphFields 
                            }
                            bookingWindowStartDate
                            bookingWindowEndDate
                            travelWindowStartDate
                            travelWindowEndDate
                            promptCardsCollection {
                                items {
                                    title
                                    image
                                    content { 
                                        ...ParagraphFields 
                                    }
                                }
                            }
                            b2BFlyer {
                                url
                                size
                                description
                            }
                            b2CFlyer {
                                url
                                size
                                description
                            }
                            socialPosts {
                                url
                                size
                                description
                            }
                            imageGalleryLink
                            termsConditionsParagraph  { 
                                ...ParagraphFields 
                            }
                        }
                    } 
                }   
            `;
    } else {
        query =`  
            ${PARAGRAPH_FRAGMENT}  
                query landingPage($contentfulId: String!, $locale: String!) {
                    landingPage(id: $contentfulId, locale: $locale) {
                        sys {
                            id
                        }
                        displayTitle
                        flyerFileCollection {
                            items {
                            url
                            size
                            description
                            }
                        }
                        flyerImageAsset
                        contentParagraph  { 
                            ...ParagraphFields 
                        }
                        bookingWindowStartDate
                        bookingWindowEndDate
                        travelWindowStartDate
                        travelWindowEndDate
                        promptCardsCollection {
                            items {
                                title
                                image
                                content { 
                                    ...ParagraphFields 
                                }
                            }
                        }
                        b2BFlyer {
                            url
                            size
                            description
                        }
                        b2CFlyer {
                            url
                            size
                            description
                        }
                        socialPosts {
                            url
                            size
                            description
                        }
                        imageGalleryLink
                        termsConditionsParagraph  { 
                            ...ParagraphFields 
                        }
                    } 
                }   
            `;
    }

    const getLandingPage = async() => {
        if(slug && slug.length > 0)
        {
            getLandingPageBySlug(query);
        }else {
            getLandingPageById(query);
        }
    }

    const getLandingPageById = async (query) => {

        await fetch(config.resourceServer.contentfulApimAgentGqlUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${oktaAuth.getAccessToken()}`,
            },
            body: JSON.stringify({
                query: query,
                variables: { contentfulId : contentfulId, locale: locale === "fr" ? locale : "en-CA"}
                }),
            })
            .then((response) => response.json())
            .then(({ data, errors }) => {
                if (errors) {
                console.error(errors);
                }else{
                    setLandingPage(data.landingPage);
                }
            });
    };

    const getLandingPageBySlug = async () => {

        await fetch(config.resourceServer.contentfulApimAgentGqlUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${oktaAuth.getAccessToken()}`,
            },
            body: JSON.stringify({
                query: query,
                variables: { slug : slug, locale: locale === "fr" ? locale : "en-CA",  brandCode:config.brand ? config.brand.toUpperCase() : 'SWG' } 
                }),
            })
            .then((response) => response.json())
            .then(({ data, errors }) => {
                if (errors) {
                console.error(errors);
                }else{
                    setLandingPage(data.landingPageCollection.items[0]);
                }
            });
    };

    useEffect(() => {
        getLandingPage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const container = document.querySelector('.page__container');
        if (container) {
            container.classList.add('landing-page');
        }
        return () => {
            if (container) {
                container.classList.remove('landing-page');
            }
        };
    }, []);

    return (
        <>
        {!config.isWestJetMode && <div className={styles.HeaderPadding}> <span>{""} </span></div>}
            {landingPage && (
                <div className={styles.flyerWrapper}>
                    <div className={styles.flyerImageContainer}>
                        <img
                            src={landingPage.flyerImageAsset?.[0]?.url}
                            alt="placeholder alt"
                        />
                    </div>
                    <div className={styles.flyerHeader}>
                        {landingPage?.displayTitle}
                    </div>
                    {landingPage?.contentParagraph && 
                        <div className={styles.flyerContent}>
                            <ParagraphConnector
                                data={landingPage?.contentParagraph}
                                locale={locale === "fr" ? locale : "en-CA"}
                            />
                        </div>
                    }
                    {landingPage?.bookingWindowStartDate && landingPage?.bookingWindowEndDate && (
                        <div>
                            <span className={styles.flyerBookingWindowText}> <RCL searchKey="booking-window" />: </span>
                            <span className={styles.flyerBookingWindowDate}>{moment(landingPage?.bookingWindowStartDate).format("MMMM DD")}{" - "}</span>  
                            <span className={styles.flyerBookingWindowDate}>{moment(landingPage?.bookingWindowEndDate).format("MMMM DD, YYYY")}</span>
                        </div>)
                    }
                    {landingPage?.travelWindowStartDate && landingPage?.bookingWindowEndDate && (
                        <div>
                            <span className={styles.flyerBookingWindowText}><RCL searchKey="travel-window" />: </span>
                            <span className={styles.flyerBookingWindowDate}>{moment(landingPage?.travelWindowStartDate).format("MMMM DD")}{" - "}</span>  
                            <span className={styles.flyerBookingWindowDate}>{moment(landingPage?.bookingWindowEndDate).format("MMMM DD, YYYY")}</span>
                        </div>)
                    }
                    {landingPage?.promptCardsCollection?.items?.length > 0 && (
                        <PromptCardGrid PromptCards={landingPage?.promptCardsCollection?.items} />) 
                    }
                    {(landingPage.b2BFlyer || landingPage.b2CFlyer || landingPage.socialPosts || landingPage.imageGalleryLink) && (
                        <>
                            <div className={styles.marketingMaterialHeader}><RCL searchKey="marketing-materials" /></div>
                            <div className={styles.marketingMaterialGridContainer}>
                                {landingPage.b2BFlyer && 
                                    <div className={styles.marketingMaterialLinkContainer}>
                                        <a className={ styles.marketingMaterialLinkButton}
                                            target="_blank"
                                            rel="noreferrer"
                                            href={landingPage.b2BFlyer.url}>
                                            <span className={styles.marketingMaterialLinkText}><RCL searchKey="download-b2b-flyer" /></span>
                                            <VWQIcon name="chevron-right" className={styles.marketingMaterialLinkIcon}/>
                                        </a>
                                    </div>
                                }
                                {landingPage.b2CFlyer && 
                                    <div className={styles.marketingMaterialLinkContainer}>
                                        <a className={styles.marketingMaterialLinkButton}
                                            target="_blank"
                                            rel="noreferrer"
                                            href={landingPage.b2CFlyer.url}>
                                            <span className={styles.marketingMaterialLinkText}><RCL searchKey="download-b2c-flyer" /></span>
                                            <VWQIcon name="chevron-right" className={styles.marketingMaterialLinkIcon}/>
                                        </a>
                                    </div>
                                }
                                {landingPage.socialPosts && 
                                    <div className={styles.marketingMaterialLinkContainer}>
                                        <a className={ styles.marketingMaterialLinkButton}
                                            target="_blank"
                                            rel="noreferrer"
                                            href={landingPage.socialPosts.url}>
                                            <span className={styles.marketingMaterialLinkText}><RCL searchKey="download-social-posts" /></span>
                                            <VWQIcon name="chevron-right" className={styles.marketingMaterialLinkIcon}/>
                                        </a>
                                    </div>
                                }
                                {landingPage.imageGalleryLink && 
                                    <div className={styles.marketingMaterialLinkContainer}>
                                        <a className={ styles.marketingMaterialLinkButton}
                                            target="_blank"
                                            rel="noreferrer"
                                            href={landingPage.imageGalleryLink}>
                                            <span className={styles.marketingMaterialLinkText}><RCL searchKey="view-image-gallery" /></span>
                                            <VWQIcon name="chevron-right" className={styles.marketingMaterialLinkIcon}/>
                                        </a>
                                    </div>
                                }
                            </div>
                        </>
                    )}
                    {landingPage?.termsConditionsParagraph && 
                        <div className={styles.termConditionContent}>
                            <ParagraphConnector
                                data={landingPage?.termsConditionsParagraph}
                                locale={locale === "fr" ? locale : "en-CA"}
                            />
                        </div>
                    }
                </div>
            )}
        </>
    )
}

export default LandingPage;